export default __webpack_public_path__ + "static/media/logo.a5bb7f0b.png";